import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpCancelService } from '@app/core/services/http.cancel.service';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class HttpCancelInterceptor implements HttpInterceptor {

  public static DISABLE_CANCEL_INTERCEPTOR = 'x-nv-please-dont-kill-me';

  constructor(private httpCancelService: HttpCancelService) { }

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    if (req.headers.has(HttpCancelInterceptor.DISABLE_CANCEL_INTERCEPTOR)) {
      return next.handle(req);
    }
    return next.handle(req).pipe(takeUntil(this.httpCancelService.onCancelPendingRequests()))
  }
}
